<template>
  <div class="inputs-block">
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 text-log-line">
        <h1 class="header">{{ 'Operating data' | i18n }}</h1>
      </div>
    </div>
    <div class="row input-line" v-for="v in values" :key="v.valueName">
      <div class="col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ v.name | i18n }}
      </div>
      <div class="col-lg-3 col-sm-12 col-xs-12 input-log-line">
        <Input v-model="value[v.valueName].value" :viewMode="!isMyTeam" placeholder="Value" />
      </div>
      <div class="col-lg-2 col-sm-12 col-xs-12 input-log-line d-flex align-items-center">
        {{ v.format }}
      </div>
      <div class="col-lg-4 col-sm-12 col-xs-12 input-log-line">
        <Input v-model="value[v.valueName].comment" :viewMode="!isMyTeam" placeholder="Comments" />
      </div>
    </div>
    <div class="row input-line">
      <div class="col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ 'Comment' | i18n }}
      </div>
      <div class="col-lg-9 col-sm-12 col-xs-12 input-log-line">
        <Textarea
          v-model="value['Comment'].value"
          :viewMode="!isMyTeam"
          placeholder="Comment"
          formGroupId="Comment"
          rows="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from '../../../../common/block-header';
import Radio from '../../../../common/radio';
import Input from '../../../../common/input';
import Textarea from '../../../../common/textarea';

export default {
  title: 'Operating data',
  components: { BlockHeader, Radio, Input, Textarea },
  props: {
    isMyTeam: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      values: [
        { name: 'Vacuum VSA West', format: 'Pa', valueName: 'Vacuum VSA West' },
        { name: 'Vacuum VSA East', format: 'Pa', valueName: 'Vacuum VSA East' },
        { name: 'Negative pressure RAB West', format: 'Pa', valueName: 'Negative pressure RAB West' },
        { name: 'Negative pressure RAB East', format: 'Pa', valueName: 'Negative pressure RAB East' },
        { name: 'Volume flow TMB', format: 'm³/h', valueName: 'Volume flow TMB' },
        { name: 'Number of waste samples', format: '', valueName: 'Number of waste samples' },
        { name: 'Stand domestic waste bunker', format: 'm', valueName: 'Stand domestic waste bunker' },
        { name: 'Stand bulky waste bunker', format: 'm', valueName: 'Stand bulky waste bunker' },
        { name: 'Stand sorting residue bunker', format: 'm', valueName: 'Stand sorting residue bunker' },
        { name: 'Stand grate ash bunker', format: 'm', valueName: 'Stand grate ash bunker' },
      ],
    };
  },
  created() {
    this.values.forEach((v) => {
      if (!this.value[v.valueName]) {
        this.value[v.valueName] = {
          value: null,
          comment: '',
        };
      }
    });
    if (!this.value['Comment']) {
      this.value['Comment'] = {
        value: '',
      };
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
}
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}
.input-line {
  padding: 10px 0;
  margin: 10px 0;
  box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
  .form-group {
    margin-bottom: 0px;
  }
}
</style>
